// test839
(839 && 0);
